/** Labels and icons mirrored from ats-api CONNECTION_PROVIDERS, plus ICS calendars. */
export const INTEGRATIONS_SETTINGS_PATH = '/settings/integrations';

export function integrationsFocusHref(focus: string): string {
  return `${INTEGRATIONS_SETTINGS_PATH}?focus=${encodeURIComponent(focus)}`;
}

export const PROVIDER_ICONS: Record<string, string> = {
  zoom: '/zoom.png',
  'google-calendar': '/google-calendar.png',
  'microsoft-calendar': '/outlook.jpg',
  'ics-calendar': '/outlook.jpg',
  'gmail-sender': '/google.svg',
  'microsoft-sender': '/microsoft.svg',
  docusign: '/docusign.png',
};

export function providerIcon(type: string): string {
  return PROVIDER_ICONS[type] || '';
}

const CONNECTION_DISPLAY_NAMES: Record<string, string> = {
  'gmail-sender': 'Gmail Sender Account',
  'microsoft-sender': 'Microsoft Sender Account',
  'google-calendar': 'Google calendar',
  'microsoft-calendar': 'Microsoft calendar',
};

export function connectionDisplayName(type: string, fallback = ''): string {
  return CONNECTION_DISPLAY_NAMES[type] || fallback;
}
